import { CustomerType } from '@shared-models';

import { IOrganizationType } from 'src/app/@interfaces/organizationType.interface';

export class OrganizationTypeMapper {
  static mapper(type: IOrganizationType | CustomerType): CustomerType {
    return {
      type: type.type,
    };
  }
}
